import apiUrl from "../../../constants";
import axios from "axios";
import iptrackerdetails from "../../../iptrackerdetails";

import Paginate from "vuejs-paginate";
import CryptoJS from "crypto-js";
import { Validator } from "vee-validate";
import VueElementLoading from "vue-element-loading";

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
    name: "userdesignation",
    components: {
        Paginate,
        VueElementLoading,
    },
    data: function () {
        return {
            modalShow: false,
            addverticalmodal: false,
            verticalaction: "",
            listverticalData: [],
            listverticalData1: [],
            listverticalData2: [],
            listverticalData3: [],
            listverticalData4: [],
            listverticalData5: [],
            listverticalData6: [],
            listuserDesignationData1: [],
            props: [],
            pageno: 0,
            pagecount: 0,
            sub_vertical: "",
            buiness_vertical: "",
            buiness_vertical_id: "",
            userDesignationId: "",
            designation_name: "",
            verticaltype: "",
            verticalfunction: 0,
            EmpCategoryName: "",
            EmpCategoryId: "",
            EmpTypeId: "",
            EmpTypeName: "",
            searchid: "",
            verticalfunctionsid: "",
            id: 0,
            isLoading: false,
            resultCount: "",
            isactive: "",
            changestatus: "",
            count: 0,
        };
    },
    async mounted() {
        var userdetailEncrypt = window.localStorage.getItem("userdetail");
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), "Key");
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail;
        this.localuserid = userdetail.userid;
        this.localusername = userdetail.username;
        await this.getdesignationMappingData();
    },
    methods: {
        addnewvertical() {
            (this.sub_vertical = ""),
                (this.designation_name = ""),
                (this.verticaltype = ""),
                (this.verticalfunction = ""),
                (this.EmpCategoryName = ""),
                (this.EmpTypeName = ""),
                (this.buiness_vertical = ""),
                (this.verticalaction = "add"),
                (this.addverticalmodal = true),
                this.getBverticalData();
            this.$validator.reset();
            this.errors.clear();
        },
        closeAddverticalModal() {
            $("#verticalform").trigger("reset");
            this.addverticalmodal = false;
            this.$validator.reset();
            this.errors.clear();
        },
        closeStatusverticalModal() {
            this.modalShow = false;
        },
        // searchData(){
        //     this.pageno = 0;
        //     this.$refs.paginate.selected = 0;
        //     this.getdesignationMappingData();
        //   },
        getdesignationMappingData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            let input = {
                offset: this.pageno,
                limit: 10,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "GetDesignationMapping ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.data.count;
                    this.resultCount = result.data.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getverticalData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            let input = {
                offset: this.pageno,
                limit: 10,
                designation_name: this.searchid,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "GetUdesignation ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count;
                    this.resultCount = result.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getverticaltypeData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            let input = {
                verticalfunctionsid: this.verticalfunction,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "Getverticaltype ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData1 = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count;
                    this.resultCount = result.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getverticalfunData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            let input = {
                buinesssubverticalsid: this.sub_vertical,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "Getverticalfunctions ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData2 = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count;
                    this.resultCount = result.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getBverticalData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            let input = {};
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "GetBverticalslist ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData3 = result.data.data.rows;
                    this.isLoading = false;
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getsubverticalData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            let input = {
                buiness_vertical_id: this.buiness_vertical,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "GetBSVerticalsList ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData4 = result.data.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count;
                    this.resultCount = result.data.count;
                    if (totalRows < 10) {
                        this.pagecount = 1;
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10);
                    }
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getuserDesignationData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            let input = {
                verticaltypeid: this.verticaltype,
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "getDesignationagainstVertical_type ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    console.log("result",result);
                    this.listuserDesignationData1 = result.data.data;
                    this.isLoading = false;
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getempcatData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            let input = {
                designationid: this.userDesignationId,
                verticaltypeid: this.verticaltype
            };
            console.log("input",this.input);
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "getEmp_catAgainstDesignation ",
                data: input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData5 = result.data.data;
                    this.isLoading = false;
                    
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        getemptypeData() {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");
            this.input = {
                designationid: this.userDesignationId,
                verticaltypeid: this.verticaltype,
                emp_cat_id: this.EmpCategoryName
            };
            this.isLoading = true;

            axios({
                method: "POST",
                url: apiUrl.api_url + "getEmp_typeAgainstEmp_cat ",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            }).then(
                (result) => {
                    this.listverticalData6 = result.data.data;
                    this.isLoading = false;
                },
                (error) => {
                    console.error(error);
                }
            );
        },
        savevertical(event) {
            var userToken = window.localStorage.getItem("userToken");
            var myStr = userToken.replace(/"/g, "");

            this.input = {
                designation_id: this.userDesignationId,
                emp_catid: this.EmpCategoryName,
                emp_type: this.EmpTypeName,
                business_vertical_id: this.buiness_vertical,
                business_subvertical_id: this.sub_vertical,
                verticalfunctions_id: this.verticalfunction,
                verticalfunctions_type_id: this.verticaltype,
            };
            axios({
                method: "POST",
                url: apiUrl.api_url + "Createdesignationmapping",
                data: this.input,
                headers: {
                    Authorization: "Bearer " + myStr,
                },
            })
                .then((response) => {
                    if (response.data.code == 200) {
                        this.$alertify.success(response.data.msg);
                        this.addverticalmodal = false;
                        event.target.reset();
                        this.resetForm();
                    } else {
                        this.$alertify.error(response.data.msg);
                    }

                    iptrackerdetails.checkUserIP(
                        this.iptrackData,
                        "Save sub vertical",
                        this.$route.path,
                        this.input,
                        response.data
                    );
                })
                .catch((httpException) => {
                    console.error("exception is:::::::::", httpException);
                });
        },

        getverticalRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.verticalaction = "edit";
            this.addverticalmodal = true;
            this.buiness_vertical_id = data.buiness_vertical_id;
            this.sub_vertical = data.sub_vertical;
            this.isactive = data.isactive;
        },
        editvertical(event) { },

        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10;
            this.getdesignationMappingData();
        },

        onSubmit: function (event) {
            this.$validator
                .validateAll()
                .then((result) => {
                    if (result) {
                        //console.log('form is valid', this.model);
                        if (this.id != undefined && this.id != "") {
                            this.editvertical(event);
                        } else {
                            this.savevertical(event);
                        }
                    }
                })
                .catch(() => {
                    console.log("errors exist", this.errors);
                });
        },
        resetSearch() {
            this.searchid = "";
            this.pageno = 0;
            this.$refs.paginate.selected = 0;
            this.getdesignationMappingData();
        },
        resetForm() {
            this.sub_vertical = "";
            this.buiness_vertical_id = "";
            this.emp_catid = "";
            this.emp_type = "";
            this.designation_id = 0;
            this.verticalaction = "add";
            this.isactive = "";
            this.$validator.reset();
            this.errors.clear();
            this.getdesignationMappingData();
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/components/designationMapping/designationMapping.js